import { DismissibleTag, styled } from 'canoe';

export const SetTag = styled(DismissibleTag)`
  position: relative;
  padding: 8px 6px 0 12px;
  min-width: 124px;

  p {
    height: 28px;
    font-size: 15px;
  }
  button {
    position: absolute;
    top: 9px;
    right: 0;
    padding: 6px;
  }
`;
